const  handleBlob= (ab, fileName) => {
  let blob = new Blob([ab]);
  let csv = window.document.createElement("a");
  csv.href = window.URL.createObjectURL(blob);
  csv.download = fileName;
  document.body.appendChild(csv);
  csv.click();
  document.body.removeChild(csv);
}
export default handleBlob;